<template>
	<div class="huaiContainer">
		<full-page :options="options" ref="fullpage">
			<div class="section pageBox1">
				<!-- 导航 -->
				<div class="navBar">
					<img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()">
					<ul class="navBarItem">
						<!-- <li class="busiz-active-sel"><router-link exact to="/" tag="a">首页</router-link></li> -->
						<li><router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link></li>
						<el-dropdown>
							<li class="brandLi"><router-link exact to="/huaiBrand" style="font-size:0.9em;"
									tag="a">兰树品牌</router-link></li>
							<el-dropdown-menu class="elDropdown" exact slot="dropdown"
								style="background:rgb(236,245,255)!important;">
								<el-dropdown-item>
									<li><router-link :class="brandActive == '1' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/huaiBrand" tag="a">淮树</router-link></li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li><router-link :class="brandActive == '2' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/brand" tag="a">心清堂</router-link></li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li><router-link :class="brandActive == '3' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/shuiBrand" tag="a">水姻缘</router-link></li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li><router-link :class="brandActive == '4' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/yiBrand" tag="a">一清堂</router-link></li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li><router-link :class="brandActive == '5' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/zhongBrand" tag="a">Dr.CHUNG<span
												style="vertical-align: super;">+</span></router-link></li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li><router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/lanshuBrand" tag="a">兰树</router-link></li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li><router-link :class="brandActive == '7' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/zbqfBrand" tag="a">植本清方</router-link></li>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
						<li><router-link to="/brandLanshu" exact tag="a">美业菩提</router-link></li>
						<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>
						
						<li><router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link></li>
						
						<li><router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link></li>
					</ul>
				</div>
				<!-- 	<div class="topBgBox" @click="enterProducts(1)">
						<img class="topBgBoxImg" src="../assets/huaiBrand/huaishuTopNew.png" alt="">
					</div> -->
			</div>
			<div class="section pageBox2">

			</div>
			<div class="section pageBox3">

			</div>
			<div class="section pageBox4">

			</div>
			<div class="section pageBox5">

			</div>
			<div class="section pageBox6">
				<div class="pageBoxOut2">
					<div class="footerBox">
						<div class="footerBoxHeader">
							<div class="footerBoxHeaderLeft">
								<img class="codeImg" src="../assets/code.png" alt="">
								<span class="codeText">兰树公众号</span>
							</div>
							<div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/xcxNew.jpg" alt="">
								<span class="codeText">兰树云小程序</span>
							</div>
						</div>
						<div class="footerMainBox">
							<li class="footerShop"><a target="_blank"
									href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
							</li>
							<li class="footerShop"><a target="_blank"
									href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
							</li>
							<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a>
							</li>
							<li class="footerShop"><a target="_blank"
									href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
							</li>
							<li class="footerShop"><a target="_blank" href="https://drchung.tmall.com"><span>Dr.CHUNG</span>旗舰店</a></li>
							<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
							<div class="lastHeader">
								<li><router-link to="/login" tag="a">登录</router-link></li>
								|
								<li><router-link to="/login" tag="a">注册</router-link></li>
							</div>
						</div>

						<div class="footerInfoBox">
							<div class="emailBox">邮箱: postermaster@lasur.com</div>
							<div class="phoneBox">电话: 0571-89025888</div>
							<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
						</div>



						<div class="footerLine"></div>
						<div class="footerBoxBottom">
							<div class="footerLeft">
								Copyright © 2023 兰树化妆品股份有限公司 <a target="_blank"
									href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> |
								<img height="16px" src="../assets/plice.png" />&nbsp;<a target="_blank"
									href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
									33052102000740号</a>
							</div>

						</div>

					</div>
				</div>
			</div>
		</full-page>
	</div>
</template>

<script>
export default {
	data() {
		return {
			options: {
				licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
				//是否显示导航，默认为false
				navigation: true,
			},
			brandActive: 1,
		}
	},
	methods: {
		enterProducts(id) {
			this.$router.push({ path: '/productsList', query: { brandId: id } });
		},
		enterHome() {
			this.$router.push({ path: '/' });
		}
	}

}
</script>

<style scoped>
.huaiContainer {
	margin: 0;
	padding: 0;
	position: relative;
}


.pageBoxOut2 {
	width: 100%;
	height: 100%;
	justify-content: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	box-sizing: border-box;
}


/* 导航 */

/* 下拉菜单栏 选中 */
.elDropdown_active {
	background-color: #FFFFFF !important;
	color: #000000 !important;
}

.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	background: #FFFFFF;
	/* border-bottom:1px solid rgba(255,255,255,0.2); */
	z-index: 999;
}

.router-link-active {
	background-color: #0F3F93 !important;
	color: #FFFFFF !important;
}

.navLogo {
	width: 10%;
	margin-left: 5em;
	cursor: pointer;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
}


.navBarItem li {
	/* list-style: none;
		padding: 1.5em 2.5em 1.5em 2.5em;
		float: left; */
	list-style: none;
	/* padding: 25px 40px 25px 40px; */
	float: left;
	/* margin-left: 2em; */
}

.brandLi a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.6em !important;
	padding-bottom: 1.6em !important;
	padding-left: 2em;
	padding-right: 2em;
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.3em;
	padding-bottom: 1.3em;
	padding-left: 1.4rem;
	padding-right: 1.4rem;
}

/* .elDropdown{
		margin-left: -7.5em;
		margin-top: -1em;
	} */

.elDropdown a {
	color: #111111;
	text-decoration: none;
}

.el-dropdown {
	vertical-align: top;
}

.el-dropdown+.el-dropdown {
	margin-left: 15px;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-icon-arrow-down {
	font-size: 12px;
}

/* pageBox1 */
.pageBox1 {
	width: 100%;
	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-34-00_35864.jpeg) no-repeat;
	background-position: 40% 20%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
}



.topBgBox {
	width: 21%;
	float: right;
	display: flex;
	align-items: center;
	top: 36%;
	right: 0%;
	opacity: 0.5;
	cursor: pointer;
	position: relative;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: topbgbox 1.5s;
	-webkit-animation: topbgbox 1.5s;
}


.topBgBoxImg {
	width: 100%;
}

.pageBox1.active .topBgBox {
	right: 30%;
	opacity: 1;
}

/* 动画 topbgbox */
/* first 图1动画 */
@keyframes topbgbox {
	from {
		opacity: 0;
		right: 0;
	}

	to {
		opacity: 1;
		right: 30%;
	}
}

@-webkit-keyframes topbgbox

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		right: 0;
	}

	to {
		opacity: 1;
		right: 30%;
	}
}

/* pageBox2 */
.pageBox2 {
	width: 100%;
	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-12-29_54458.jpg) no-repeat;
	background-position: center 60%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

/* pageBox3 */
.pageBox3 {
	width: 100%;
	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-25-08_27744.jpg) no-repeat;
	background-position: 50% 50%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
	align-items: auto;
}

.pageTopTitle {
	font-size: 2.2rem;
	font-family: SimSun;
	font-weight: bold;
	color: #222222;
	line-height: 20px;
	text-align: center;
}

.pageBoxMainBody3 {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 5%;
}

.itemBox1 {
	display: flex;
	flex-direction: column;
	position: relative;
	top: -5rem;
	opacity: 0.5;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.pageBox3.active .itemBox1 {
	top: 0;
	opacity: 1;
}

.itemBoxTitle1 {
	font-size: 1.2rem;
	font-family: PingFangSC-Regular, PingFang SC;
	color: #111111;
	font-weight: 400;
	line-height: 25px;
	margin-top: 1rem;
}

.itemBoxImg {
	width: 100%;
}

.itemBoxImg1 {
	width: 100%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
}


.itemBoxImg2 {
	width: 85%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
}

.addImg {
	width: 100%;
}

.addBox {
	margin-left: 7%;
}

.itemBox2 {
	margin-left: 9%;
}


.itemBox3 {
	margin-left: 7%;
}

.pageBoxMainBodyBottom {
	font-size: 1.1rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #111111;
	line-height: 25px;
	width: 50%;
	margin: 0 auto;
	text-align: center;
	position: relative;
	top: 40%;
	opacity: 0.5;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.pageBox3.active .pageBoxMainBodyBottom {
	top: 8%;
	opacity: 1;
}

/* pageBox4 */

.pageBox4 {
	width: 100%;
	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-30-12_18628.jpg) no-repeat;
	background-position: 50% 50%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
	align-items: auto;
}

.pageBoxMain4 {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 12%;
}

.flowerBox1 {
	width: 13%;
	position: absolute;
	float: left;
	left: 0;
	bottom: 0;
	z-index: 999;
}


.flowerBox2 {
	width: 13%;
	position: absolute;
	float: right;
	right: 0;
	bottom: 0;
	z-index: 999;
}

.flowerImg2 {
	width: 100%;
}


.flowerImg1 {
	width: 100%;
}

.pageBoxMainLeft {
	width: 45%;
}

.pageBoxMainImg {
	width: 100%;
}

.pageBoxMainRight {
	width: 35%;
	display: flex;
	flex-direction: column;
	position: relative;
	left: 25rem;
	opacity: 0.5;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.pageBox4.active .pageBoxMainRight {
	left: 8rem;
	opacity: 1;
}


.pageBoxMainRightTop {
	font-size: 2rem;
	font-family: simsun;
	color: #FFFFFF;
	font-weight: bold;
	line-height: 33px;
	letter-spacing: 1px;
}

.pageBoxMainRightBottom {
	font-size: 1.125rem;
	opacity: 0.9;
	color: #FFFFFF;
	line-height: 46px;
	margin-top: 1rem;
}



/* pageBox5 */

.pageBox5 {
	width: 100%;
	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-37-22_36862.jpg) no-repeat;
	background-position: 50% 50%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
	align-items: auto;
}

.pageBoxMain5 {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 12%;
}


.pageBoxMainLeft2 {
	width: 45%;
	margin-left: 1rem;
}

.pageBoxMainImg {
	width: 100%;
}

.pageBoxMainRight2 {
	width: 45%;
	display: flex;
	flex-direction: column;
	position: relative;
	left: -20rem;
	opacity: 0;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.pageBox5.active .pageBoxMainRight2 {
	left: 0;
	opacity: 1;
}


.pageBoxMainRightTop2 {
	font-size: 2rem;
	font-family: simsun;
	font-weight: bold;
	color: #111111;
	line-height: 33px;
	letter-spacing: 1px;
}

.pageBoxMainRightBottom2 {
	font-size: 1.125rem;
	font-family: PingFangSC-Regular, PingFang SC;
	opacity: 0.9;
	color: #111111;
	line-height: 46px;
	margin-top: 1rem;
}

/* pageBox6 */
.pageBox6 {
	width: 100%;
	background-color: #620c0b;
	display: flex;
	flex-direction: column;
}


/* footer */
.footerBox {
	width: 90%;
	/* height: 287px; */
	/* position:absolute;
	   	bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
}


.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}

.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderCenter {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderMiddle {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}



.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #FFFFFF;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}


.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}



.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 24px;
}


.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
}

.footerLeft a:hover {
	color: #003F98;
}


.footerMiddle {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerMiddle span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 24px;
}

.footerRight {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerRight li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 28px;
}

.footerRight li {
	list-style: none;
}

.footerLast {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerLast span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}



.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span{
	margin-right: 10px;
}
.footerShop span::after{
	content: '+';
	display:block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #FFFFFF;
	padding-left: 2em;
	line-height: 28px;
	cursor: pointer;
}


.seriesTitle {
	margin: 0 auto;
	text-align: center;
	font-size: 2rem;
	margin-top: 2%;
	font-weight: bold;
	font-family: SimSun;
}

.seriesMainBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 2%;
}

.seriesMainBoxItem {
	width: 100%;
}

.seriesItemImg {
	width: 30%;
	cursor: pointer;
}


.seriesItemImg1 {
	position: relative;
	left: 0%;
	top: 10rem;
	opacity: 0;
	-moz-transition: 0.8s;
	-webkit-transition: 0.8s;
}

.seriesItemImg2 {
	position: relative;
	left: 0%;
	top: 3rem;
	opacity: 0;
	-moz-transition: 0.8s;
	-webkit-transition: 0.8s;
}

.seriesItemImg3 {
	position: relative;
	float: right;
	right: 0%;
	top: 4rem;
	opacity: 0;
	-moz-transition: 0.8s;
	-webkit-transition: 0.8s;
}

.seriesItemImg4 {
	position: relative;
	float: right;
	right: 0%;
	top: 6rem;
	opacity: 0;
	-moz-transition: 0.8s;
	-webkit-transition: 0.8s;
}

.pageBox2.active .seriesItemImg1 {
	opacity: 1;
	left: 35%;
}


.pageBox2.active .seriesItemImg2 {
	opacity: 1;
	left: 20%;
}


.pageBox2.active .seriesItemImg3 {
	opacity: 1;
	right: 18%;
}

.pageBox2.active .seriesItemImg4 {
	opacity: 1;
	right: 35%;
}

.busiz-text-ellipes1 {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}
</style>



// WEBPACK FOOTER //
// src/components/lanshuBrand.vue